
import { defineComponent, nextTick, onMounted, onUpdated, ref } from "vue";
import { DrawerComponent } from "@/assets/ts/components/_DrawerOptions";
import { ToggleComponent } from "@/assets/ts/components/_ToggleComponent";
import { ScrollComponent } from "@/assets/ts/components/_ScrollComponent";
import KTMenu from "@/layout/aside/Menu.vue";
import { listGhlLocations } from "@/api/ghl.api.js";
import { vCheckOverride } from "@/api/override";
import { getCurrentUser } from "@/utils/index";

export default defineComponent({
  name: "KTAside",
  components: {
    KTMenu
  },
  props: {
    lightLogo: String,
    darkLogo: String
  },
  setup() {
    const user = ref<any>(null);
    const hasAi247 = ref(false);

    const loadAi247Status = async () => {
      if (!user.value) {
        hasAi247.value = false;
        return;
      }

      try {
        // Skip GHL for override-capable admins (as themselves or while overriding).
        // Calling locations/mine for these sessions can return "Session not found"
        // and force a full app logout via the analytics interceptor.
        const overrideResponse = await vCheckOverride();
        if (overrideResponse?.data?.override === true) {
          hasAi247.value = false;
          await nextTick();
          ScrollComponent.reinitialization();
          return;
        }

        const response = await listGhlLocations();
        const locations = Array.isArray(response.data?.locations)
          ? response.data.locations
          : [];
        const pending = Array.isArray(response.data?.pendingActivationIds)
          ? response.data.pendingActivationIds
          : [];
        hasAi247.value = locations.length > 0 || pending.length > 0;
      } catch {
        hasAi247.value = false;
      }

      await nextTick();
      ScrollComponent.reinitialization();
    };

    onMounted(() => {
      user.value = getCurrentUser();
      DrawerComponent.reinitialization();
      ToggleComponent.reinitialization();
      loadAi247Status();
    });

    onUpdated(() => {
      ToggleComponent.bootstrap();
    });

    return {
      user,
      hasAi247
    };
  }
});
